import axiosConfig from "./axiosConfig";
import { DocumentIdRecord } from "./getDocumentIds";

const patchDocumentId = async (
  authToken: string,
  type: string,
  number: number,
  body: { isVoided: boolean }
): Promise<DocumentIdRecord> => {
  const { data } = await axiosConfig.patch(
    `/document-ids/${type}/${number}`,
    body,
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    }
  );
  return data;
};

export default patchDocumentId;
